<template>
  <div>

  <div class="row" id="topspace">
    <div class="col-md-12">
      <ul id="AllCabSlider">
        <li v-for="(data, key, index) in all_cabs" :data-id="data.id" v-on:click="cabClicked(data.id)"  v-bind:class="{'current':(current_cab.id == data.id)}">
            <router-link v-bind:to="'/catalog/' +data.id" >
              <div class="TextOverlay">
                      <h4 class="bold">{{ data.title }}</h4>
                      <p  class="bold hidden-sm hidden-xs">{{ data.sub_title }}</p>
              </div>
              <img :src="base_path + data.catalogimages[0]" class="responsive" @load="loaded" />
            </router-link>
        </li>
      </ul>
    </div>
  </div>


  <div id="greyArea" ref="greyArea">
    <section class="ContentAligher SectionSpacing">
      <div class="row">
        <div class="col-md-6 v_middle">
          <ul id="ImageGal">
            <template  v-for="item in current_cab.catalogimages" >
            <li :data-thumb="base_path + item">
              <img :src="base_path + item" class="responsive">
            </li>
            </template>
          </ul>
        </div><!--
        --><div class="col-md-6 v_middle">
          <div id="HeroTitle">
            <h1 class="bold white">
              <span class="small">{{ current_cab.title}}</span> 
              <span class="mid">{{ current_cab.sub_title}}</span> 
            </h1> 
            <p class="white">{{ current_cab.description}}</p> 
            <p  v-if="current_cab.customizable == '1'"><span class="link" v-on:click="selectPanals(0);"><img :src="require('@/assets/images/customize-btn.png')"></span></p>
          </div>
        </div>
      </div>
    </section>
  </div>



<div  ref="CabCustomizer"></div>
    <section id="CabCustomizer" class="ContentAligher SectionSpacing" v-show="custom_cab.image">
      <div class="row">
        <div class="col-md-6 hidden-md hidden-lg"><!--pull-right-md-->
            <div id="Cab_c_image_mob">
              <img :src="base_path + currentImage" class="responsive">
            </div>
        </div>
        <div class="col-md-5 col-md-offset-1 v_middle" ref="FormScroll">
          <h1 class="bold">Customize my CAB</h1><br/><br/>
          <form name="CabForm" id="CabcontactForm" class="contactForm " @submit.prevent="CabProcessForm" >
                      <div class="row">
                        <div class="col-sm-12">
                          <div id="form-result"></div>
                        </div>
                      </div>


                      <div class="row">
                        <div class="col-sm-6">
                          <div class="field">
                            <label for="full_name" class="block">Full Name *</label>
                            <span v-show="errors.has('full_name')" class="help is-danger">{{ errors.first('full_name') }}</span>
                            <input type="text" name="full_name" id="full_name" class="responsive" placeholder=" " v-model="full_name" v-validate="'required'" >
                            
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <label for="phone" class="block">Phone *</label>
                            <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
                            <input type="tel" name="phone" id="phone" class="responsive" placeholder=" " v-model="phone" v-validate="'required|numeric'" >
                          </div>
                        </div>


                        <div class="col-sm-6">
                          <div class="field">
                            <label for="email" class="block">Email *</label>
                            <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                            <input type="email" name="email" id="email" class="responsive" placeholder=" " v-model="email" v-validate="'required|email'" >
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <label for="company" class="block">Company *</label>
                            <span v-show="errors.has('company')" class="help is-danger">{{ errors.first('company') }}</span>
                            <input type="text" name="company" id="company" class="responsive" placeholder=" " v-model="company" v-validate="'required'" >
                          </div>
                        </div>
                      </div>

                      <hr/>

          <table class="customiseCabTbl">
            <tr>
              <td>Select Panel:</td>
              <td>
                <ul id="selectPanals">
                  <li v-for="(data, key, index) in current_cab.c_options" :data-id="key" v-on:click="selectPanals(key)" v-bind:class="{'current':(data.panal_img == custom_cab.selected_panal)}">
                    <img :src="base_path + data.panal_img" class="responsive">
                  </li>
                </ul>
                <input type="hidden" name="selected_panal" id="selected_panal" :value="custom_cab.selected_panal" >
              </td>
            </tr>
            <tr>
              <td>Apply Panels to:</td>
              <td>
                <select name="apply_panals_to" v-model="apply_panals_to" v-validate="'required'">
                <option :value="key" v-for="(data, key, index) in panal_l"  v-bind:selected="key === custom_cab.apply_panals_to">
                  {{ data }}
                </option>
              </select>
                <span v-show="errors.has('apply_panals_to')" class="help is-danger block">{{ errors.first('apply_panals_to') }}</span>
              </td>
            </tr>
            <tr>
              <td>No of Cabs:</td>
              <td>
                <input type="number" name="no_of_cabs" min="1" v-model="no_of_cabs" v-validate="'required'">
                <span v-show="errors.has('no_of_cabs')" class="help is-danger block">{{ errors.first('no_of_cabs') }}</span>
              </td>
            </tr>
            <tr>
              <td>Cab Height:</td>
              <td>
                <input type="text" name="cab_height" v-model="cab_height" v-validate="'required'">
                <span v-show="errors.has('cab_height')" class="help is-danger block">{{ errors.first('cab_height') }}</span>
              </td>
            </tr>
            <tr>
              <td>Cab Dimensions:</td>
              <td>
                <input type="text" name="cab_dimensions" v-model="cab_dimensions" v-validate="'required'">
                <span v-show="errors.has('cab_dimensions')" class="help is-danger block">{{ errors.first('cab_dimensions') }}</span>
              </td>
            </tr>
            <tr>
              <td></td>
              <td><em>Please enter all measurements in inches</em></td>
            </tr>

            <tr>
              <td></td>
              <td>
                <vue-recaptcha sitekey="6LeCifkUAAAAAKgCVQnMF52ZoNQZYevMlpb7HEsE" :loadRecaptchaScript="true"></vue-recaptcha>
              </td>
            </tr>
            <tr>
              <td></td>
              <td><button class="button" id="CabSubmitContact">Build a Quotation</button></td>
            </tr>
          </table>




                      
          </form>

        </div><!--
        --><div class="col-md-5 hidden-sm hidden-xs v_middle"><!--pull-right-md-->
            <div id="Cab_c_image_desk">
              <img :src="base_path + currentImage" class="responsive">
            </div>
        </div>
      </div>
    </section>

    <rwv-general-form></rwv-general-form>
  </div>
</template> 
<script>

//import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueRecaptcha from 'vue-recaptcha';

import axios from 'axios'
import { API_BASE_URL } from '../config'
import { BASE_URL } from '../config'

Vue.use(VeeValidate);


import '@/assets/js/easyResponsiveTabs'
import '@/assets/js/lightslider'
import RwvGeneralForm from '@/components/GeneralForm';

Vue.component('card1', {
  template: '<div>Card:<span style="background-color:green">{{title}}</span></div>',
  props: ['custom_cab']
})

export default{
  name: 'catalog',
  components: {
    RwvGeneralForm,
    VueRecaptcha
  },
  data: function() {
    return {
     base_path: BASE_URL,
     current_cab: {
                    "id": null,
                    "created_at": "",
                    "updated_at": "",
                    "title": "",
                    "sub_title": "",
                    "description": "",
                    "catalogimages": [],
                    "customizable": 0,
                    "c_options": []
                  },
     all_cabs: [],
     custom_cab:{ 
                  "selected_panal": "",
                  "apply_panals_to": "",
                  "image": ""
                },
     panal_l: ['Side walls and Back wall', 'Side walls only', 'Back wall only'],
      selected_panal: '',
      apply_panals_to: '',
      no_of_cabs : '',
      cab_height: '',
      cab_dimensions: '',
      full_name: '',
      email: '',
      phone: '',
      company: '',
    }
  },
  mounted() {

      axios.get(API_BASE_URL + 'catalog/' + this.$route.params.id )
      .then(response => {this.current_cab = response.data}).finally(function(){

          var slider = $('#ImageGal').lightSlider({
            gallery:true,
            item:1,
            vertical:true,
            verticalHeight:600,
            vThumbWidth:150,
            thumbItem:3,
            currentPagerPosition: 'left',
            thumbMargin:4,
            slideMargin:0,
            responsive : [
                {
                    breakpoint:800,
                    settings: {
                        item:1,
                        slideMove:1,
                        verticalHeight:500,
                        vThumbWidth:150,
                      }
                },
                {
                    breakpoint:480,
                    settings: {
                      verticalHeight:450,
                        item:1,
                        slideMove:1,
                        vThumbWidth:50,
                      }
                }
            ]
          }); 
      });


    axios.get(API_BASE_URL + 'catalog/list/?customizable=1')
    .then(response => {this.all_cabs = response.data}).finally(function(){
          var slider2 = $('#AllCabSlider').lightSlider({
            item:4,
            slideMove:1,
            enableTouch:true,
            enableDrag:false,
            loop:false,
            slideMargin:0,
            responsive : [
                {
                    breakpoint:1367,
                    settings: {
                        item:4,
                        slideMove:1,
                      }
                },
                {
                    breakpoint:800,
                    settings: {
                        item:3,
                        slideMove:1,
                      }
                },
                {
                    breakpoint:480,
                    settings: {
                        item:2,
                        slideMove:1,
                      }
                }
            ]
          }); 
    });


  },
  watch: {
    '$route.params.id': function (id) {
      //this.$forceUpdate()
      axios.get(API_BASE_URL + 'catalog/' + this.$route.params.id )
      .then(response => {this.current_cab = response.data});
      //slider2.refresh();
      $("#CabCustomizer").fadeOut();
      this.scrollMeTo('greyArea');
    }
  },
  updated(){

     //$(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
     setTimeout(function() {
          $(this).trigger('resize');
      }, 100);

  },
  computed: {
            // currentImage gets called whenever activeImage changes
            // and is the reason why we don't have to worry about the 
            // big image getting updated
            currentImage() {
                return this.custom_cab.image;
            }
        },
  methods: {
      cabClicked:function (e) {
        //window.location.href = 'catalog/'+e;
        //this.$router.push(e) ;
      },
      selectPanals:function (e) {
        //window.location.href = e;
        this.custom_cab.image = this.current_cab.c_options[e].actual_img;
        this.custom_cab.selected_panal = this.current_cab.c_options[e].panal_img;
        this.custom_cab.apply_panals_to = this.current_cab.c_options[e].panal_to;
        
        $("#CabCustomizer").fadeIn();
        this.scrollMeTo('CabCustomizer');
      },
      loaded:function (e) {
        $(this).trigger('resize');
      },
      CabProcessForm: function() {
      //console.log({ name: this.name, email: this.email });
      //alert('Processing!');

        this.$validator.validateAll().then((result) => {
        if (result) {
            //alert("success");
      
              //replace submit button with loader
              $( "#CabSubmitContact" ).fadeOut('fast', function(){
                  $( '<img src="'+ require('../assets/images/loader.gif') +'" id="loader_gif" />' ).insertAfter(this);
              });

              // Send the data using post
              var form = $( "#CabcontactForm" );  
              var posting = $.post('https://elevinteriors.com/ajax/cab_bilder.php', form.serialize() );

              // Put the results in a div
              posting.done(function( data ) {
                var obj = $.parseJSON(data);
                $( "#form-result" ).empty().append( obj.msg );
                this.scrollMeTo("FormScroll");

                if(obj.success == 'true')
                {
                  //success
                  form.find("input[type=text], input[type=email], input[type=tel], input[type=number], textarea").val("");//reset
                }
                $( "#CabSubmitContact" ).fadeIn('fast', function(){
                  $( '#loader_gif' ).remove();
                });
              });

        }
        });      
    },
    scrollMeTo(refName) {

        var element = this.$refs[refName];
        var top = element.offsetTop;

        window.scrollTo(0, top);
    }

  }
}

</script>
<style>
@import './../assets/css/easyResponsiveTabs.css';
@import './../assets/css/lightslider.css';
#ImageGal li img{ display:block; margin:0px auto; }
</style>


// WEBPACK FOOTER //
// src/views/CabBuilder.vue